import React from 'react'
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";
import {useDispatch, useSelector} from "react-redux";
import {setShowForm} from "../reducers";
import {useFormContext} from "react-hook-form";
import FlaveRadioButton from "./form_fields/raw_fields/flave_radio_button";

const DeclineRadioButtonContent = () => {
  const dispatch = useDispatch()

  const {formState: { errors }} = useFormContext();

  const declineMode = useSelector(state => state.decline_mode) || "disabled"

  const acceptRadioButtonText = useSelector(state => state.accept_radio_button_text)
  const declineRadioButtonText = useSelector(state => state.decline_radio_button_text)

  const onDeclineRadioButtonChange = (e) => {
    console.log("CHANGE", e)
    if (declineMode === "with_radio_button_without_form") {
      dispatch(setShowForm(e.target.value === "0"))
    }
  }

  const options = [
    {
      label: declineRadioButtonText,
      value: "1"
    },
    {
      label: acceptRadioButtonText,
      value: "0"
    }
  ]

  return <FlaveRadioButton
    name={"decline.status"}
    label={""}
    options={options}
    onChange={onDeclineRadioButtonChange}
    errorMessage={errors["tag_owner.decline"]?.message}
  />
}

export default DeclineRadioButtonContent;